'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateEmailValidator;
var _regex = require('./regex');
var _regex2 = _interopRequireDefault(_regex);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// Copied from @energysavvy/customer-email-api
var VALID_EMAIL_REGEX = '^[^ @]+@(?:[a-zA-Z0-9_-]+\\.)+\\w{2,}$';
function generateEmailValidator(message) {
  return (0, _regex2.default)(VALID_EMAIL_REGEX, message);
}